export const LogoutIcon: React.FC = () => (
	<svg
		id='_005-logout'
		data-name='005-logout'
		xmlns='http://www.w3.org/2000/svg'
		width='21.189'
		height='21.19'
		viewBox='0 0 21.189 21.19'>
		<g id='Group_4578' data-name='Group 4578' transform='translate(0)'>
			<g id='Group_4577' data-name='Group 4577'>
				<path
					id='Path_3407'
					data-name='Path 3407'
					d='M307.441,152.533a.893.893,0,0,0-.192-.288L304.6,149.6a.883.883,0,1,0-1.248,1.248l1.142,1.142h-4.932a.883.883,0,1,0,0,1.766h4.932l-1.142,1.142a.883.883,0,1,0,1.248,1.248l2.648-2.648a.874.874,0,0,0,.192-.288A.884.884,0,0,0,307.441,152.533Z'
					transform='translate(-286.319 -143.158)'
					fill='#3b2a82'
				/>
				<path
					id='Path_3408'
					data-name='Path 3408'
					d='M15.024,12.361a.883.883,0,0,0-.883.883v4.415H10.609V3.532a.884.884,0,0,0-.63-.846l-3.066-.92h7.228V6.181a.883.883,0,0,0,1.766,0V.883A.883.883,0,0,0,15.024,0H.9A.787.787,0,0,0,.806.017.872.872,0,0,0,.432.147C.412.16.388.161.37.175S.36.19.353.2A.875.875,0,0,0,.118.474.721.721,0,0,0,.093.548a.837.837,0,0,0-.07.207.55.55,0,0,0,0,.077C.026.849.014.865.014.883V18.542a.882.882,0,0,0,.71.865l8.829,1.766a.822.822,0,0,0,.173.018.884.884,0,0,0,.883-.883v-.883h4.415a.883.883,0,0,0,.883-.883v-5.3A.883.883,0,0,0,15.024,12.361Z'
					transform='translate(-0.014)'
					fill='#3b2a82'
				/>
			</g>
		</g>
	</svg>
)
